import { z } from 'zod';
import { idSchema, isoDateTimeSchema, paginationQuerySchema } from './primitives';
/**
 * Bureaux (cahier des charges §9).
 *
 * Le bureau est l'unité de cloisonnement du système : chaque reçu et chaque
 * utilisateur appartient à un et un seul bureau. Un bureau n'est jamais
 * supprimé — il est désactivé — afin que les archives conservent une
 * référence valide pendant toute leur durée de conservation.
 */
export const branchCodeSchema = z
    .string()
    .trim()
    .min(2, 'Le code doit comporter au moins 2 caractères')
    .max(12, 'Le code ne peut dépasser 12 caractères')
    .regex(/^[A-Z0-9-]+$/, 'Code en majuscules, chiffres et tirets uniquement');
export const branchSchema = z.object({
    id: idSchema,
    code: branchCodeSchema,
    name: z.string().min(2).max(120),
    city: z.string().max(120).nullable(),
    address: z.string().max(240).nullable(),
    phone: z.string().max(40).nullable(),
    timezone: z.string().min(1).max(64),
    isActive: z.boolean(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const branchWithStatsSchema = branchSchema.extend({
    userCount: z.number().int().nonnegative(),
    receiptCount: z.number().int().nonnegative(),
    lastArchivedAt: isoDateTimeSchema.nullable(),
});
export const createBranchSchema = z.object({
    code: branchCodeSchema,
    name: z.string().trim().min(2, 'Nom trop court').max(120),
    city: z.string().trim().max(120).optional(),
    address: z.string().trim().max(240).optional(),
    phone: z.string().trim().max(40).optional(),
    timezone: z.string().trim().min(1).max(64).default('Africa/Kinshasa'),
});
export const updateBranchSchema = createBranchSchema.partial().extend({
    isActive: z.boolean().optional(),
});
export const listBranchesQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    isActive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((value) => (typeof value === 'boolean' ? value : value === 'true'))
        .optional(),
});
//# sourceMappingURL=organization.js.map